import { ABOUT_URL } from "@/config/site";
import { CtaButton } from "./CTA";
import { MaskLines, Reveal, Eyebrow } from "./Motion";

export const WhyPitchally = () => (
  <section id="about" data-testid="about-section" className="border-t border-white/10 bg-pa-surface">
    <div className="mx-auto grid max-w-[1400px] gap-12 px-5 py-section-sm sm:px-8 lg:grid-cols-12 lg:px-12 lg:py-section">
      <div className="lg:col-span-6">
        <Reveal><Eyebrow>About / 08</Eyebrow></Reveal>
        <MaskLines lines={["Why", <span className="text-glow text-pa-orange">Pitchally?</span>]} label="Why Pitchally?" className="mt-6 font-display text-[clamp(3.5rem,10vw,9rem)] uppercase leading-[0.85]" />
      </div>
      <Reveal delay={0.15} className="self-end lg:col-span-6">
        <p className="font-display text-3xl uppercase leading-tight tracking-wide text-pa-ink md:text-4xl">
          The music industry has changed. The way artists build careers should change with it.
        </p>
        <p className="mt-6 text-base leading-relaxed text-pa-muted md:text-lg">
          Pitchally exists to give independent creators more control, better information and access to the infrastructure required to build sustainable music careers.
        </p>
        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-pa-dim">A product of Pitchclerk Music Group</p>
        <CtaButton variant="ghost" href={ABOUT_URL} target="_blank" rel="noopener noreferrer" data-testid="about-cta" className="mt-10">
          About Pitchally
        </CtaButton>
      </Reveal>
    </div>
  </section>
);
